// removed by extract-text-webpack-plugin
module.exports = {"ItemsContainer":"SideDrawerList__ItemsContainer__1f6pm"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Lists/SideDrawerList/SideDrawerList.css
// module id = 6144
// module chunks = 0